import React from "react";

const Background = () => {
    return(
        <>
            <div className="Background-main">
                <div className="circle1"></div>
                <div className="circle2"></div>
            </div>
            <div className="Background-overlay"></div>
        </>
    );
}

export default Background;